import AlgorithmsPage from '@/modules/quant/algorithms/algorithms-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/algorithms/',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: AlgorithmsPage,
});
